import moment from 'moment';

document.addEventListener('DOMContentLoaded', function () {
    const parentTenderSelect = $('#parent_id').select2();
    parentTenderSelect.on('select2:select', function (e) {
        const parentId = e.params.data.id;

        if (parentId) {
            fetch(`/tenders/${parentId}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error('Something went wrong');
                    }
                })
                .then(data => {
                    Object.entries(data.data).forEach(([key, value]) => {
                        if (key !== 'parent_id') {
                            const input = $(`#tenderParentForm [name="${key}"]`);
                            if (input.is('select')) {
                                input.val(value).trigger('change');
                            } else if (input.hasClass('datepicker-input') && value) {
                                const formattedDate = moment.utc(value).format('DD. MM. YYYY');

                                input.val(moment.utc(value).format('YYYY-MM-DD'));
                                const flatpickrInput = document.querySelector(`#tenderParentForm [data-for="${key}"]`);
                                const flatpickrInstance = flatpickrInput._flatpickr;
                                flatpickrInstance.setDate(formattedDate);
                            } else {
                                input.val(value);
                            }
                        }
                    });

                    $('select').each(function () {
                        if (this.name !== 'parent_id') {
                            $(this).select2();
                        }
                    });
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const parentTenderSelect = $('#parent_id').select2();

    function saveInitialRequiredState() {
        document.querySelectorAll('input[required], select[required]').forEach(element => {
            element.dataset.wasRequired = 'true';
            element.removeAttribute('required');
        });
    }

    function updateRequiredAttributes(isVisible) {
        const elements = document.querySelectorAll('input, select');
        elements.forEach(element => {
            if (isVisible) {
                if (element.dataset.wasRequired === 'true') {
                    element.setAttribute('required', 'required');
                }
            } else {
                element.removeAttribute('required');
            }
        });
    }

    function toggleFormVisibility(isVisible) {
        if (isVisible) {
            $('#tenderChildForm').removeClass('d-none');
        } else {
            $('#tenderChildForm').addClass('d-none');
        }
    }


    saveInitialRequiredState();

    const initialParentId = parentTenderSelect.val();
    const isVisible = !!initialParentId;
    toggleFormVisibility(isVisible);
    updateRequiredAttributes(isVisible);

    parentTenderSelect.on('select2:select', function (e) {
        const parentId = e.params.data.id;
        const isVisible = !!parentId;
        toggleFormVisibility(isVisible);
        updateRequiredAttributes(isVisible);

    });
});

document.addEventListener('DOMContentLoaded', function () {
    const periodInput = document.querySelector('[name="validity_period_months"]');
    const fromInput = document.querySelector('[name="validity_from"]');
    const toInput = document.querySelector('[name="validity_to"]');

    if (!periodInput || !fromInput || !toInput) return;

    function calculateValidityTo() {
        if (toInput.value.trim() !== '') return;

        const period = parseInt(periodInput.value, 10);
        const fromDateStr = fromInput.value;
        if (!period || !fromDateStr) return;

        const fromDate = new Date(fromDateStr);
        if (isNaN(fromDate.getTime())) return;

        let newDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + period, fromDate.getDate());
        newDate.setDate(newDate.getDate() - 1);

        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
        const formattedDate = `${day}. ${month}. ${year}`;

        toInput.value = `${year}-${month}-${day}`;
        const flatpickrInput = document.querySelector('[data-for="validity_to"]');
        const flatpickrInstance = flatpickrInput && flatpickrInput._flatpickr;
        if (flatpickrInstance) {
            console.log(flatpickrInstance);
            flatpickrInstance.setDate(formattedDate);
        }
    }

    periodInput.addEventListener('input', calculateValidityTo);
    fromInput.addEventListener('input', calculateValidityTo);
});

// Handle terms_of_payment auto-fill from Account selection
document.addEventListener('DOMContentLoaded', function () {
    const accountSelect = $('#account_id');
    const termsOfPaymentInput = document.querySelector('#terms_of_payment');

    if (!accountSelect.length || !termsOfPaymentInput) return;

    accountSelect.on('select2:select', function (e) {
        const accountId = e.params.data.id;

        if (accountId) {
            fetch(`/accounts/${accountId}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error('Failed to fetch account data');
                    }
                })
                .then(data => {
                    const termsOfPayment = data.data.terms_of_payment;

                    // Only auto-fill if current value is empty or zero
                    const currentValue = termsOfPaymentInput.value;
                    if (!currentValue || currentValue === '0' || currentValue === '') {
                        if (termsOfPayment !== null && termsOfPayment !== undefined) {
                            termsOfPaymentInput.value = termsOfPayment;
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching account data:', error);
                });
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const productSelect = $('[name="product_id"]');
    const productSelectNative = document.querySelector('[name="product_id"]');
    const offerPriceInput = document.querySelector('input[name="offer_price_per_unit"]');

    if ((!productSelect.length && !productSelectNative) || !offerPriceInput) return;

    const fetchAndFill = (productId) => {
        if (!productId) return;

        fetch(`/products/${productId}`, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            }
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Failed to fetch product data');
                }
            })
            .then(data => {
                const price = data?.data?.price;

                if (price !== undefined && price !== null) {
                    offerPriceInput.value = price;
                    offerPriceInput.dispatchEvent(new Event('input'));
                }
            })
            .catch(error => {
                console.error('Error fetching product data:', error);
            });
    };

    if (productSelect.length) {
        productSelect.on('select2:select', function (e) {
            const productId = e.params.data.id;
            fetchAndFill(productId);
        });
    }

    if (productSelectNative) {
        productSelectNative.addEventListener('change', function () {
            const productId = this.value;
            fetchAndFill(productId);
        });
    }
});
